<template>
	<module class="module-config" title="照片墙配置">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="模块名称" required>
				<c-input name="title"></c-input>
			</c-form-item>
			<c-form-item ref="list" name="list" label="照片墙内容" required>
				<c-grid-row v-if="dataList.length" column="2" gap>
					<c-grid-col v-for="(item, i) in dataList" :key="i" class="group">
						<div class="group-index">{{i + 1}}</div>
						<div class="group-handle flex">
							<a v-if="i > 0" class="flex-center" @click="sortHandle(i, -1)"><i class="tf-sort-up"></i></a>
							<a v-if="i < dataList.length - 1" class="flex-center" @click="sortHandle(i, 1)"><i class="tf-sort-down"></i></a>
							<a class="flex-center" @click="dataList.splice(i, 1)"><i class="tf-cross"></i></a>
						</div>
						<c-form ref="itemForm" unit-width="100%">
							<c-form-item label="上传照片" required>
								<c-upload-file v-model="item.image" name="image" type="image" media tip="建议尺寸：1200×800"></c-upload-file>
							</c-form-item>
							<c-form-item label="照片描述">
								<c-input v-model="item.name" name="name" maxlength="50"></c-input>
							</c-form-item>
						</c-form>
					</c-grid-col>
				</c-grid-row>
				<div class="group-add flex-center" @click="uploadHandle()"><i class="tf-add"></i>添加照片</div>
			</c-form-item>
			<c-form-item label="展示样式" required>
				<c-radio-group name="style">
					<c-radio value="1">轮播图</c-radio>
					<c-radio value="2">双列图</c-radio>
					<c-radio value="4">四宫格</c-radio>
				</c-radio-group>
			</c-form-item>
			<c-form-item label="自动切换时间" required>
				<c-select name="interval" :options="autoSwitchOptions" :clear="false"></c-select>
			</c-form-item>
			<c-form-item label="切换动画" required>
				<c-radio-group name="animation">
					<c-radio value="1">水平滚动</c-radio>
					<c-radio value="2">淡入淡出</c-radio>
				</c-radio-group>
			</c-form-item>
		</c-form>
	</module>
</template>

<script>
	export default {
		data() {
			return {
				dataList: [],
				autoSwitchOptions: [{
					name: '5秒',
					value: 5
				}, {
					name: '7秒',
					value: 7
				}, {
					name: '10秒',
					value: 10
				}, {
					name: '15秒',
					value: 15
				}]
			}
		},

		methods: {
			pushHandle(data) {
				this.dataList.push(Object.assign({
					image: '',
					name: ''
				}, data));
				this.$refs.list.warn(false);
			},

			sortHandle(index, dir) {
				this.dataList.splice(index + dir, 0, this.dataList.splice(index, 1)[0]);
			},

			uploadHandle() {
				this.$upload({
					count: Infinity,
					type: 'image',
					size: this.$compsConfig.config.file.size,
					loading: true,
					success: data => {
						data.forEach(item => {
							this.pushHandle({
								image: item.signPath
							});
						});
					}
				});
			},

			setConfig(config = {}) {
				this.$refs.form.set(Object.assign({
					style: 1,
					interval: 5,
					animation: 1
				}, config.data));

				if (config.data && config.data.list.length) {
					this.dataList = config.data.list;
				}
			},

			getConfig() {
				return new Promise(resolve => {
					Promise.all([
						new Promise(resolve => {
							this.$refs.form.validate({
								rule: {
									title: '请填写模块名称',
									list: [{
										type: 'function',
										message: '请添加照片墙内容',
										fun: () => {
											return this.dataList.length > 0;
										}
									}]
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					].concat((this.$refs.itemForm || []).map($form => {
						return new Promise(resolve => {
							$form.validate({
								rule: {
									image: '请上传照片'
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					}))).then(data => {
						if (data.findIndex(item => item === false) == -1) {
							resolve({
								type: 7,
								data: Object.assign(this.$refs.form.get(), {
									list: this.dataList
								})
							});
						} else {
							resolve(false);
						}
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		position: relative;
		border-radius: 6px;
		padding: 26px 26px 16px 16px;
		background: #F9F9F9;

		&-index {
			position: absolute;
			left: 0;
			top: 0;
			width: 18px;
			border-radius: 6px 0 6px 0;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #0081FA;
			background: #E0EDF9;
		}

		&-handle {
			position: absolute;
			right: 0;
			top: 0;
			border-radius: 0 6px 0 6px;
			overflow: hidden;
			background: #eee;

			a {
				width: 18px;
				height: 18px;
				font-size: 12px;
				color: #aaa;

				&:hover {
					color: var(--color-main);
				}

				&:nth-last-child(1) {
					color: #fff;
					background: #f55;
				}
			}
		}

		&-add {
			gap: 6px;
			height: 38px;
			border: 1px dashed var(--color-main);
			border-radius: 6px;
			font-size: 14px;
			color: var(--color-main);
			cursor: pointer;

			&:hover {
				border-color: var(--color-main-hover);
				color: var(--color-main-hover);
			}

			&:nth-child(n+2) {
				margin-top: 10px;
			}
		}
	}

	.color-list {
		gap: 8px;
		padding: 2px 0;

		li {
			box-sizing: border-box;
			width: 34px;
			height: 34px;
			border: 1px solid #fff;
			border-radius: 100%;
			cursor: pointer;

			&:hover,
			&.z-crt {
				border-color: var(--color-main);
			}

			div {
				width: 22px;
				height: 22px;
				border: 1px solid #ddd;
				border-radius: 100%;
			}
		}
	}

	>>> .data-filter .filter li:nth-child(1):nth-last-child(1) {
		padding-top: 4px;
	}
</style>